
import { Vue } from "vue-property-decorator";
import Loader from "@/components/Loader.vue";
import Table, { Column } from "@/components/Table.vue";
import PrintButton from "@/components/PrintButton.vue";

export default Vue.extend({
  name: "Hauptwerte",
  components: {
    Loader,
    Table,
    PrintButton
  },
  props: ["id"],
  data: () => ({
    tablehauptwerte: [
      { text: "Abfluss in m3/s", key: "key" },
      { text: "Winter-Halbjahr", key: "wh" },
      { text: "Sommer-Halbjahr", key: "sh" },
      { text: "Abflussjahr", key: "ah" },
      { text: "Datum", key: "datum_ah" }
    ] as Column[],

    tablehochwasserTop10: [
      { text: "Rang", key: "rang" },
      { text: "Datum", key: "datum" },
      { text: "Abfluss in m³/s", key: "abfluss" },
      { text: "Abflussspende in l/(s*km²)", key: "abflussspende" },
      { text: "Wasserstand in cm", key: "wasserstand" }
    ] as Column[],

    tableniedrigwasserTop10: [
      { text: "Rang", key: "rang" },
      { text: "Datum", key: "datum" },
      { text: "Abfluss in m³/s", key: "abfluss" },
      { text: "Abflussspende in l/(s*km²)", key: "abflussspende" }
    ] as Column[]
  })
});
